export const colors = [
  "pink",
  "purple",
  "teal",
  "green",
  "orange",
  "red",
  "sky",
] as const;
export type Color = (typeof colors)[number];

// Renames applied when 3B adopted the brand palette. Step configs and badge
// configs committed before that point still carry the old name; resolve them
// on read so the rendered UI uses the new token.
//   amber  → orange  (orange replaced amber's "warm/warning" role)
//   yellow → orange  (intermediate name during brand-palette migration)
//   blue   → sky     (sky replaced blue in the picker; --blue-* removed)
const RENAMED: Record<string, string> = {
  amber: "orange",
  yellow: "orange",
  blue: "sky",
};
export function normaliseColor(c: string): string {
  return RENAMED[c] ?? c;
}

export function isColor(c: string): c is Color {
  return (colors as readonly string[]).includes(c);
}

export function colorFromSeed(seed: string): Color {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  return colors[Math.abs(hash) % colors.length]!;
}

export function resolveStepColor(rawColor: string, seed: string): Color {
  const renamed = normaliseColor(rawColor);
  return isColor(renamed) ? renamed : colorFromSeed(seed);
}
